import { combineReducers } from "redux";
import { ParsedRecord } from "../../types/airtable";
import { Action } from "./actions";

export interface RecordState {
  records: ParsedRecord[];
  loading: boolean;
  error: any;
}

export interface State {
  records: RecordState;
}

const initState: RecordState = {
  records: [],
  loading: false,
  error: null
};

const records = (
  state: RecordState = initState,
  action: Action
): RecordState => {
  switch (action.type) {
    case "FETCH_RECORDS_BEGIN":
      return { ...state, loading: true };
    case "FETCH_RECORDS_SUCCESS":
      return { ...state, records: action.payload, loading: false };
    case "FETCH_RECORDS_FAILURE":
      return { ...state, error: action.error };
    default:
      return state;
  }
};

export default combineReducers<State>({
  records
});
